<section class="space-ptb">
  <div class="container">
    <div class="row">
      <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
        <div class="feature-info feature-info-border p-4 text-center">
          <div class="feature-info-icon mb-3">
            <i class="flaticon-placeholder"></i>
          </div>
          <div class="feature-info-content">
            <h5 class="text-black">Address</h5>
            <span class="d-block">214 West Arnold St. </span>
            <span>New York, NY 10002</span>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
        <div class="feature-info feature-info-border p-4 text-center">
          <div class="feature-info-icon mb-3">
            <i class="flaticon-contact fa-flip-horizontal"></i>
          </div>
          <div class="feature-info-content">
            <h5 class="text-black">Phone Number</h5>
            <span class="d-block">(123) 345-6789</span>
            <span>(456) 478-2589</span>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 mb-4 mb-md-0">
        <div class="feature-info feature-info-border p-4 text-center">
          <div class="feature-info-icon mb-3">
            <i class="flaticon-approval"></i>
          </div>
          <div class="feature-info-content">
            <h5 class="text-black">Email</h5>
            <span class="d-block">support@jobber.demo</span>
            <span>gethelp@jobber.demo</span>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6">
        <div class="feature-info feature-info-border p-4 text-center">
          <div class="feature-info-icon mb-3">
            <i class="flaticon-curriculum"></i>
          </div>
          <div class="feature-info-content">
            <h5 class="text-black">Fax</h5>
            <span class="d-block">(123) 345-6789</span>
            <span>(456) 478-2589</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="space-ptb pt-0">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="section-title-02 text-center">
          <h2>Let’s Get In Touch!</h2>
          <p>We have completed over a 1000+ projects for five hundred clients. Give us your next project.</p>
        </div>
      </div>
    </div>
    <form [formGroup]="contactUsForm" class="needs-validation" novalidate *ngIf="contactUsForm">
      <div class="form-row">
        <div class="form-group col-md-6">
          <input type="text" class="form-control" id="Name" placeholder="Enter Your Name" formControlName="name">
          <div class="text-danger mt-1" *ngIf="canShowValidation('name')">
            {{ getValidationMessage("name") }}
          </div>
        </div>
        <div class="form-group col-md-6">
          <input type="text" class="form-control" id="Subject" placeholder="Subject" formControlName="subject">
          <div class="text-danger mt-1" *ngIf="canShowValidation('subject')">
            {{ getValidationMessage("subject") }}
          </div>
        </div>
        <div class="form-group col-md-6">
          <input type="text" class="form-control" id="email" placeholder="Enter Your Email Address" formControlName="email">
          <div class="text-danger mt-1" *ngIf="canShowValidation('email')">
            {{ getValidationMessage("email") }}
          </div>
        </div>
        <div class="form-group col-md-6">
          <input type="number" class="form-control" id="phone" placeholder="Enter Your Phone Number" formControlName="phoneNumber">
          <div class="text-danger mt-1" *ngIf="canShowValidation('phoneNumber')">
            {{ getValidationMessage("phoneNumber") }}
          </div>
        </div>
        <div class="form-group col-12 mb-0">
          <textarea rows="5" class="form-control" id="details" placeholder="Details" formControlName="details"></textarea>
          <div class="text-danger mt-1" *ngIf="canShowValidation('details')">
            {{ getValidationMessage("details") }}
          </div>
        </div>
        <div class="col-12 text-center mt-4">
          <a class="btn btn-primary" (click)="handleContactUsSubmission()">Send your message</a>
        </div>
      </div>
    </form>
  </div>
</section>